import { QuoteEventType } from '../../../enums/quoteEventType'
import type { QuoteEvent } from '../../../types/quotes/quoteEvent'

export const getApprovedInvoiceId = (events: QuoteEvent[]): number | undefined =>
  events.find((e) => e.eventType === QuoteEventType.DocumentInvoiced)?.eventData?.approvedInvoiceId
